var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/** @jsx h */

import { createImageUrl } from '@nrk/serum-imagecrop-utils';
import { h, Component } from 'preact';
import { createResponsiveSrcSet } from '../../helpers';

var SerumLazyResponsivePicture = function (_Component) {
  _inherits(SerumLazyResponsivePicture, _Component);

  function SerumLazyResponsivePicture() {
    _classCallCheck(this, SerumLazyResponsivePicture);

    return _possibleConstructorReturn(this, (SerumLazyResponsivePicture.__proto__ || Object.getPrototypeOf(SerumLazyResponsivePicture)).apply(this, arguments));
  }

  _createClass(SerumLazyResponsivePicture, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.load && !this.props.load) {
        this.loadImage();
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'loadImage',
    value: function loadImage() {
      var _this2 = this;

      var loaderImage = new Image();
      if (this.visibleImage.dataset) {
        loaderImage.srcset = this.visibleImage.dataset.srcset || '';
        loaderImage.sizes = this.visibleImage.sizes || '';
      }
      loaderImage.src = this.visibleImage.dataset.src;
      if (typeof loaderImage.decode === 'function') {
        // Use Image Decode API to decode image upfront if available
        // (Unsure if this works when transferring src to other image, but worth the try)
        loaderImage.decode().then(function () {
          return _this2.updateImage(loaderImage);
        });
      } else if (loaderImage.complete) {
        this.updateImage(loaderImage);
      } else {
        loaderImage.onload = function () {
          return _this2.updateImage(loaderImage);
        };
      }
    }
  }, {
    key: 'updateImage',
    value: function updateImage(loaderImage) {
      var _this3 = this;

      requestAnimationFrame(function () {
        _this3.visibleImage.src = loaderImage.currentSrc || loaderImage.src;
        _this3.visibleImage.style.filter = 'blur(0)';
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          className = _props.className,
          alt = _props.alt,
          id = _props.id,
          _props$quality = _props.quality,
          quality = _props$quality === undefined ? 0.6 : _props$quality,
          _props$ratio = _props.ratio,
          ratio = _props$ratio === undefined ? '16:9' : _props$ratio,
          sizes = _props.sizes;


      var placeholderSrc = createImageUrl({ id: id, width: 100, quality: 0.6, ratio: ratio });

      var defaultUrl = createImageUrl({ id: id, width: 1600, quality: quality, ratio: ratio });

      var sourceSet = createResponsiveSrcSet({ id: id, quality: quality, ratio: ratio });

      return h(
        'picture',
        { className: className, style: { display: 'block', overflow: 'hidden' } },
        h('img', {
          src: placeholderSrc,
          alt: alt,
          'data-src': defaultUrl,
          'data-srcset': sourceSet,
          style: { width: '100%', filter: 'blur(10px)', transition: 'filter 500ms' },
          sizes: sizes,
          ref: function ref(elm) {
            return _this4.visibleImage = elm;
          }
        })
      );
    }
  }]);

  return SerumLazyResponsivePicture;
}(Component);

export default SerumLazyResponsivePicture;